module.exports = __webpack_public_path__ + "assets/img/guide-sm.d6933b80.jpg";